import {Component, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {IDialogComponent} from "../../../../dialog/iDialog.component";
import {TagsEditDialogInput} from "../tags-edit-dialog/tags-edit-dialog.component";
import {DialogWithInput} from "../../../../dialog/dialogWithInput";
import {DialogModule} from "../../../../dialog/dialog.module";
import {TagSummaryFindAllService} from "../../service/tagSummaryFindAll.service";
import {UrlParameterBuilder} from "../../../../../core/http/UrlParameterBuilder";
import {Order, Sort, UrlParameter} from "../../../../../../shared/utils/url.builder";
import {CardModule} from "../../../../../core/component/card/card.module";
import {PaginatedListDataModule} from "../../../../../core/component/paginated-list-data/paginated-list-data.module";
import {TagSummaryPaginatedService} from "../../service/tagSummaryPaginated.service";
import {TagItemComponent} from "../tag-item/tag-item.component";
import {TagDeleteService} from "../../service/tagDelete.service";

export interface TagsManagementDialogInput {
  entityTypeValue: string;
}

@Component({
  selector: 'app-tags-management-dialog',
  templateUrl: './tags-management-dialog.component.html',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    CardModule,
    PaginatedListDataModule,
    TagItemComponent,
  ],
  providers: [
    TagSummaryPaginatedService,
  ]
})
export class TagsManagementDialogComponent implements IDialogComponent<TagsManagementDialogInput, void>,
  OnInit {
  dialog: DialogWithInput<TagsManagementDialogInput, void>;
  parameters: UrlParameter[] = [];
  sort = new Sort('name', Order.ASCENDING);

  constructor(public service: TagSummaryPaginatedService) {
  }

  ngOnInit(): void {
    this.parameters = new UrlParameterBuilder()
        .addParameter('entityType.value', this.dialog.input.entityTypeValue)
        .parameters;
  }


}
